// extracted by mini-css-extract-plugin
export default {"backButton":"backButton__6qTVN"};
    if(module.hot) {
      // 1788784371709
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  